import { combineReducers } from "redux";
import App from './app';
import Chat from './chat';

export default combineReducers({
    App,
    Chat
});